import React from 'react';
import { gql } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { Link, Text } from '@xyz-school/xyz-react-frontend';

import Dashboard from '@/pages/Dashboard';
import BreadcrumbsWrapper from '@/features/BreadcrumbsWrapper';
import { PageStreamBreadCrumbsFragment } from '@/generated/graphql';

gql`
    fragment PageStreamBreadCrumbs on LiveStreamType {
        title
    }
`;

type Props = {
    data?: PageStreamBreadCrumbsFragment;
};

const PageStreamBreadCrumbs = ({ data }: Props) => {
    const { t } = useTranslation(['stream']);

    if (!data) {
        return null;
    }

    return (
        <BreadcrumbsWrapper>
            <Link to={Dashboard.getUrl(Dashboard.tab.Streams)}>{t('TITLE')}</Link>
            <Text>{data?.title}</Text>
        </BreadcrumbsWrapper>
    );
};

export default PageStreamBreadCrumbs;
